export default "__VITE_ASSET__01009384__"